import { Suspense, lazy, memo } from 'react';
import { Box, Spinner, Center, useMediaQuery } from '@chakra-ui/react';

import BreadCrumbComponent from 'components/BreadCrumb';

import { TabType } from '../types';

// Lazy load heavy components
const Dashboard = lazy(() => import('pages/ModelOverviewPage/Dashboard-v2'));
const BlockList = lazy(() => import('pages/ModelOverviewPage/block'));
const Dimensions = lazy(() => import('pages/ModelOverviewPage/dimensions'));
const DataImport = lazy(() => import('pages/ModelOverviewPage/Import'));

interface TabContentProperties {
  activeTab: TabType;
  blocks?: any[];
}

const LoadingFallback = () => (
  <Center h='200px'>
    <Spinner size='xl' color='#745BE3' thickness='4px' />
  </Center>
);

const TabContent = memo(({ activeTab, blocks }: TabContentProperties) => {
  const [isTablet] = useMediaQuery('(max-width: 768px)');
  // Dashboard fills the full remaining viewport height and manages its own layout.
  // Other tabs get a breadcrumb header and standard content padding.
  const isDashboard = activeTab === 'dashboard';

  return (
    <Box height='calc(100vh - 60px)' bg='gradient.body' overflow={isDashboard ? 'hidden' : 'auto'}>
      {!isDashboard && (
        <Box px={isTablet ? 4 : 7} pt={3}>
          <BreadCrumbComponent hasBlock={false} />
        </Box>
      )}
      <Box p={isDashboard ? 0 : 6} height={isDashboard ? '100%' : 'auto'}>
        <Suspense fallback={<LoadingFallback />}>
          {activeTab === 'dashboard' && <Dashboard />}
          {activeTab === 'blocks' && <BlockList blocks={blocks || []} />}
          {activeTab === 'dimensions' && <Dimensions />}
          {activeTab === 'import' && <DataImport />}
        </Suspense>
      </Box>
    </Box>
  );
});

TabContent.displayName = 'TabContent';

export default TabContent;
